<template>
  <label
    :class="{ 'bg-white border-green': isChecked }"
    class="border-2 p-4 mb-2 rounded bg-white-ter hover:bg-white"
  >
    <v-icon
      :type="isChecked ? 'check-circle': 'circle'"
      :class="{ 'text-green': isChecked }"
      size="lg"
      class="mr-4"
    />
    <input
      v-model="valueLocal"
      :value="value"
      v-bind="$attrs"
      class="hidden"
      type="radio"
    >
    <slot/>
  </label>
</template>

<script>
import { generateComputedWithEmit } from '@/utils/componentUtils'

/**
 * @module VRadio
 */
export default {
  name: 'VRadio',
  inheritAttrs: false,
  model: {
    prop: 'checked'
  },
  props: {
    checked: {
      type: [Boolean, String],
      required: true
    },
    value: {
      type: [String, Boolean],
      required: true
    }
  },
  computed: {
    valueLocal: generateComputedWithEmit('checked'),
    isChecked () {
      return this.valueLocal === this.value
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
